import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Contrato, ContratoForm, TipoContrato } from '../../../../base/vo/contrato';
import { Field, SelectOptions } from '../../../../base/vo/formulario';


@Component({
  selector: 'app-form-novo',
  templateUrl: './form-novo.component.html',
  styleUrls: ['./form-novo.component.scss']
})
export class FormNovoComponent implements OnInit {
  @Input() loading: boolean;
  @Input() contrato: Contrato;
  @Input() tiposContrato: TipoContrato[];

  @Output() contratoFormEmitter: EventEmitter<ContratoForm> = new EventEmitter();

  public formGroup: FormGroup;
  public fields: Field[] = [
    {
      controlName: 'titulo',
      label: 'Titulo Documento',
    },
    {
      controlName: 'tipoDocumento',
      label: 'Tipo do documento',
      options: [
        {
          id: 'contrato',
          name: 'Contrato',
          value: '1'
        },
        {
          id: 'aditivo',
          name: 'Aditivo',
          value: '2'
        },
        {
          id: 'orientacoes',
          name: 'Orientações Gerais',
          value: '3'
        },
        {
          id: 'compromisso',
          name: 'Termo de Compromisso',
          value: '4'
        },
      ]
    },
    {
      controlName: 'observacao',
      label: 'Observação',
    },
    {
      controlName: 'documento',
      label: 'Documento',
    },
  ];

  constructor(
    private readonly formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      titulo: ['', [Validators.required]],
      tipoDocumento: ['', [Validators.required]],
      observacao: ['', [Validators.required]],
      documento: ['', [Validators.required]],
    });

    if (this.tiposContrato) {
      this.fields[1].options = this.tiposContrato.map(tipo => {
        const selectOptions: SelectOptions = {
          id: tipo.id.toString(),
          name: tipo.nomeTipoDocumento,
          value: tipo.id.toString(),
        };

        return selectOptions;
      });
    }

    if (this.contrato) {
      this.setFields();
    }
  }


  private checkFormValidations(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(campo => {
      const control = formGroup.get(campo);
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty();
      if (control instanceof FormGroup) {
        this.checkFormValidations(control);
      }
    });
  }

  private setFields() {
    this.formGroup.controls.titulo.setValue(this.contrato.titulo);
    this.formGroup.controls.tipoDocumento.setValue(
      this.fields[1].options.find(x => x.name === this.contrato.tipoDocumento).value
    );
    this.formGroup.controls.observacao.setValue(this.contrato.observacao);
    this.formGroup.controls.documento.setValue(this.contrato.documento);
  }

  public onSubmit() {
    this.checkFormValidations(this.formGroup);
    if (this.formGroup.valid) {
      this.contratoFormEmitter.emit(this.formGroup.value);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos-novo/form-novo/form-novo.component.ts